export type Listener<T> = (value: T) => void

/** Minimal observable value. Enough for Phase 0; no extra dependency. */
export class Store<T> {
  private listeners = new Set<Listener<T>>()

  constructor(private value: T) {}

  get(): T {
    return this.value
  }

  set(next: T): void {
    if (Object.is(next, this.value)) return
    this.value = next
    for (const l of this.listeners) l(next)
  }

  /** Returns an unsubscribe function. */
  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }
}
